import { ModuleWithProviders, NgModule } from '@angular/core';
import { CreditCardCongif } from './interfaces/credit-card-config.interface';
import { CreditCardComponent } from './credit-card.component';
import { CreditCardService } from './credit-card.service';
import { CREDIT_CARD_CONFIG } from './configs/credit-card.config';


@NgModule({
  declarations: [CreditCardComponent],
  providers: [CreditCardService],
  exports: [CreditCardComponent]
})
export class CreditCardModule {

  static forRoot(config?: CreditCardCongif): ModuleWithProviders<CreditCardModule> {
    return {
      ngModule: CreditCardModule,
      providers: [
        { provide: CREDIT_CARD_CONFIG, useValue: config },
        CreditCardService
      ],
    }
  }

}
